var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocTranslHomepageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47583 9.58737C4.67831 7.29446 6.17882 5.49026 8.44253 5.07302C11.2806 4.5499 16.1346 4 24 4C31.8654 4 36.7194 4.5499 39.5575 5.07302C41.8212 5.49026 43.3217 7.29446 43.5242 9.58738C43.7621 12.2823 44 16.7814 44 24C44 31.2186 43.7621 35.7177 43.5242 38.4126C43.3217 40.7055 41.8212 42.5097 39.5575 42.927C36.7194 43.4501 31.8654 44 24 44C16.1346 44 11.2806 43.4501 8.44253 42.927C6.17882 42.5097 4.67831 40.7055 4.47583 38.4126C4.23786 35.7177 4 31.2186 4 24C4 16.7814 4.23786 12.2823 4.47583 9.58737Z",
    fill: "#DCE2F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0156 4.16628C19.0249 4.06286 21.3398 4 23.999 4C26.6582 4 28.9731 4.06286 30.9824 4.16628L30.1538 12.4517C30.0814 13.1761 29.2838 13.5828 28.6549 13.216L27.1545 12.3407C26.8017 12.1349 26.3591 12.1644 26.0367 12.4151L24.6358 13.5047C24.2642 13.7937 23.7413 13.7844 23.3802 13.4824L22.1345 12.4402C21.8174 12.175 21.3698 12.1322 21.0082 12.3325L19.3276 13.2638C18.6991 13.6121 17.9194 13.2036 17.8479 12.4886L17.0156 4.16628Z",
    fill: "#6491CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29C26 27.8954 26.8954 27 28 27H36C37.1046 27 38 27.8954 38 29C38 30.1046 37.1046 31 36 31H28C26.8954 31 26 30.1046 26 29Z",
    fill: "#6491CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36C29 34.8954 29.8954 34 31 34H36C37.1046 34 38 34.8954 38 36C38 37.1046 37.1046 38 36 38H31C29.8954 38 29 37.1046 29 36Z",
    fill: "#6491CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocTranslHomepageIcon);
export default __webpack_public_path__ + "static/media/docTranslHomepageIcon.9082e385383a7cb01a24925ce3c8f0c5.svg";
export { ForwardRef as ReactComponent };